/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrgsAuthProviders = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-auth-provider/getAll`,param).then(res => res.data)
}
const createOrgAuthProvider = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-auth-provider/create`,app).then(res => res.data)
}
const editOrgAuthProvider = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-auth-provider/update`,app).then(res => res.data)
}
const getOrgAuthProviderHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-auth-provider/get-history`,param).then(res => res.data)
}
const getAllOrgsAuthProvidersByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-auth-provider/getAllByOrganizationID`,param).then(res => res.data)
}
export {
    getAllOrgsAuthProviders,
    createOrgAuthProvider,
    editOrgAuthProvider,
    getOrgAuthProviderHistory,
    getAllOrgsAuthProvidersByOrgID
}
